import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { tabs } from "./staffWeeklyHoursTabs";
import { DetailTabs } from "../../components/detailTabs/DetailTabs";
import { EntityForm } from "../../components/entityForm/EntityForm";
import { Groups } from "../../components/groups/Groups";
import { staffWeeklyHoursOptions } from "./staffWeeklyHoursOptions";

export const fieldsQuery = [
	"staff_agreement.id,staff_agreement.user.id,staff_agreement.user.first_name,staff_agreement.user.last_name",
	"id,date_start,date_end,weekly_hours,fixed_days_off,day_off_type,agreement_type,holidays_settlement",
].join(",");

export const staffWeeklyHoursRoutes = [
	{
		path: "/staff_weekly_hours",
		element: <Records entity="staff_weekly_hours" fieldsQuery={fieldsQuery} options={staffWeeklyHoursOptions.groupsOptions} />,
	},
	{
		path: "/staff_weekly_hours/:id",
		element: (
			<Record
				entity="staff_weekly_hours"
				fieldsQuery={fieldsQuery}
				type="detail"
				body={<DetailTabs tabs={tabs} />}
			/>
		),
		children: [
			{
				path: "/staff_weekly_hours/:id/detail",
				element: <Groups groupsOptions={staffWeeklyHoursOptions.groupsOptions} />,
			},
		],
	},
	{
		path: "/staff_weekly_hours/:id/update",
		element: <Record entity="staff_weekly_hours" fieldsQuery={fieldsQuery} type="update" body={<EntityForm groupsOptions={staffWeeklyHoursOptions.groupsOptions} />} />,
	},
	{
		path: "/staff_weekly_hours/create",
		element: (
			<Record
				entity="staff_weekly_hours"
				type="create"
				body={<EntityForm groupsOptions={staffWeeklyHoursOptions.groupsOptions} />}
			/>
		),
	},
];
